const hello_world = "Hello World!";

// Roles Start
// IMPORTANT ! IF values must be identical to constants to laravel app
const manager = 1;
const coursecreator = 2;
const editingteacher = 3;
const teacher = 4;
const student = 5;
const guest = 6;
const user = 7;
const frontpage = 8;
const trainingmanager = 10;
const privacyofficer = 11;
const localmanager = 12;
const wsuser = 13;
const teamlead = 14;
const regionmanager = 15;
const instructor = 16;
const it = 17;

const siteadmin = 18;
const sparkforeadmin = 19;
// Roles End
// Local Storage
const auth_user = "auth_user";

// Local Storage

// TEXT
const common_error_title = "Something Went Wrong";

const general_password_validation_message =
  "The password should contain minimum 6 characters with 1 Uppercase character, 1 Lowercase character and 1 digit with a symbol such as `-=_)(*^%$@!~";
const subdomain_can_contain_alphanumeric_chars_message =
  "The subdomain can contain alpha numeric characters only";
const censorship_triggered_message =
  "Censored words found in your subdomain. Please re-check and try again";
const subdomain_not_available_message =
  "The Subdomain is not available please try another";
const choose_different_subdomain_message =
  "Please choose a different subdomain name. Similar available subdomain names:";
const sparkfore_welcome_message = "Hello Welcome to Sparkfore";

const add_new_customer_button_label = "Add New Customer";
const customer_label = "Customer";
const organization_number_label = "Organization Number";
const guid_label = "GUID";
const secret_key_label = "Secret Key";
const lms_url_label = "LMSurl";
const license_type_label = "License Type";
const select_license_placeholder = "Select License";
const customer_instance_id_label = "Customer Instance ID : ";
const customer_settings_header = "Customer Settings";
const stripe_connect_account_header = "Stripe Connect Account";
const create_account_button_label = "Create Account";
const save_settings_button_label = "Save Settings";
const add_new_customer_info_message =
  "Important : Customer Instance ID generated automatically, is an increment of the last generated ID";
const account_name_label = "Account Name";
const delete_stripe_connect_account_message =
  "Are you sure you want to delete this account?";

const company_email_input_label = "Company Email";
const company_number_input_label = "Company No.";
const company_name_input_label = "Company Name";
const company_name_input_label_s = "Company Name";
const phone_input_label = "Phone";

const invoicing_address_input_label = "Invoicing Address";
const zip_code_input_label = "Zip Code";

const account_manager_input_label = "Our Account Manager";
const customer_team_lead_ac_input_label = "Customer Team Lead Account";
const save_changes_button_label = "Save Changes";
const customer_profile_retrieval_error_message =
  "Customer Profile retrieval was failed";
const customer_profile_retrieval_status_heading =
  "Customer Profile retrieval Status";
const customer_profile_update_success_heading = "Updating Customer Success";
const customer_profile_update_success_message = "Updating Customer Success";
const customer_profile_update_fail_heading = "Updating Customer Failed";
const customer_profile_update_fail_message = "Updating Customer Failed";
const customer_profile_update_status_heading = "Customer Update Status";
const customer_profile_update_error_message = "Creating Customer Failed";
const close_button_label = "Close";

const signup_forms_heading = "Sign-up Forms";
const overview_tab_title = "Overview";
const signup_form_list_item_custom_description_title = "Custom Description";
const signup_forms_no_data_text =
  "You haven’t created any forms yet. Start by clicking";
const signup_forms_no_data_add_form_text = "Add Form";
const custom_title_input_label = "Custom Title";
const custom_title_input_placeholder = "Enter Your Title";
const custom_description_input_label = "Custom Description";
const custom_description_input_placeholder = "Enter Your Description Here";
const logo_input_label = "Logo";
const logo_input_placeholder = "Choose a file or drop it here...";
const logo_input_drop_placeholder = "Drop file here...";
const add_other_fields_input_group_label = "Add Other Fields";
const add_fields_button_label = "Add Fields";
const delete_fields_button_label = "Delete Fields";
const delete_field_button_label = "Delete Field";
const delete_form_warning_message = "Do you want to delete the form?";
const link_copied_success_toast_message = "Link Copied to Clipboard";
const update_form_heading = "Update Form";
const courses_to_enrol_after_signup_input_label =
  "Courses to get enrolled in after signup";
const select_courses_placeholder = "Select Courses";
const select_courses_tag_placeholder = "Add this course";
const registration_domain_limit_input_label = "Limit registration to domains";
const registration_domain_limit_tag_placeholder = "Type new domain";
const max_allowed_registrations_input_label = "Maximum allowed registrations";
const proceed_to_create_form_button_label = "Proceed to Create Form";
const proceed_to_generate_link_button_label =
  "Proceed to Generate Sharing Link";
const signup_form_share_helper_text =
  "To share the Signup Form, please share the link generated below:";
const generated_link_input_group_label = "Generated Link";
const generated_link_placeholder = "Generated URL";
const copy_url_address_button_label = "Copy URL Address";
const back_to_overview_button_label = "Back to Overview";
const company_name_placeholder_label = "ABC Company PVT (ltd)";

// Subscription
const my_subscription_title = "My Subscription";
const subscription_payment_helper_text =
  "You can choose card payment for this order";
const participants_title = "Participants";
const participant_invoice_helper_text = "You can choose invoice for this order";
const new_participants_per_month_text = "New per month";
const participants_all_time_text = "All time";
const subscription_status_error_heading = "Subscription Status";
const subscription_status_error_message = "Reading Subscription Failed";
const error_retrieving_subscription_heading = "Reading Subscription Failed";
const no_subscription_id_message =
  "Looks like we could not get your Subscription id";
const customer_instance_creation_failed_message =
  "Creating Customer Instance was a failure";
const retrieving_session_error_heading = "Reading Session Failed";
const subscription_creation_success_message = "Creating Subscription Success";
const subscription_creation_error_message = "Creating Subscription Failed";
const invoice_payment_label = "Invoice";
const card_payment_label = "Card";
const pending_card_payment_label = "Pending card payment";

const no_invoice_message = "There are no pending invoices at the moment";
const no_order_message = "There are no orders at the moment";
const date_label = "Date";
const date_range_label = "Date Range";
const no_company_message =
  "There are no companies registered for this user (as the team lead) at the moment";

const order_details_label = "Order Details";
const name_label = "Name";
const email_label = "Email";
const options_label = "Options";
const approve_btn_label = "Approve";
const decline_btn_label = "Decline";
const invoice_approval_heading = "Invoice Approval";
const order_history_heading = "Order History";
const course_title_label = "Course Title";
const quantity_label = "Quantity";
const order_sum_label = "Order Sum";
const payment_method_label = "Payment Method";
const purchaser_name_label = "Purchaser's Name";
const view_order_label = "View Order";

const invalid_input_error_message = "Invalid Input";

//Customer Account Portal
const portal_licenses_title = "Course Licenses";
const portal_licenses_helper_text = "Available course licenses";
const portal_coursecompletions_title = "Course Completions";
const portal_coursecompletions_helper_text = "Number of course completions";
const portal_certificaterenewals_title = "Certificate Renewals";
const portal_certificaterenewals_helper_text = "Certificates for renewal";
const last30days = "Last 30 days";
const thisyear = "This year";
const next3months = "Next 3 months";
const next12months = "Next 12 months";
const last12months = "Last 12 months";

const webshop_header_text = "Webshop";
const enable_webshop_helper_text =
  "To enable the webshop, Please click the below button and onboard your Stripe Connect Account";
const onboard_your_account_button_label = "Onboard Your Account";
const generated_webshop_code_text_group_text = "My generated webshop code";
const generate_code_button_label = "Generate Code";
const in_webshop_column_title = "In-Webshop";
const course_title_column_title = "Course Title";
const price_column_title = "Price";
const shop_preview_tab_title = "Shop Preview";
const webshop_save_error_message =
  "Some of the fields in the webshop are not filled properly. Please check the price and language fields and try again";
const iframe_copied_success_text = "iFrame Copied to Clipboard";
const approximation_time_text = "Approximate time";
const languages_placeholder = "Languages";
const length_text = "Length";
const shop_text = "Shop";
const not_available_short_text = "N/A";

const courses_header_text = "Courses";
const settings_tab_title = "Settings";

const username_input_placeholder = "Username";
const password_input_placeholder = "Password";
const login_button_label = "Login";
const forgot_password_link_label = "Forgot Password?";

const email_input_placeholder = "E-mail";
const send_password_reset_link_button_label = "Send Password Reset Link";
const back_to_login_button_label = "Back to Login";

const form_image_alt_text = "Form image";
const form_not_available_text =
  "Unfortunately This form is not available right now.";
const account_created_success_text =
  "Account Created! You will be redirected to the account.";

const registration_successful_with_redirection_text =
  "Successfully Registered! You will be redirected to the Platform in a few moment";
const create_webshop_payment_failed_text = "Creating WebShop Payment Failed";
const payment_status_heading = "Payment Status";
const contintue_with_payment_button_label = "Continue with Payment";
const sign_in_tab_title = "Sign In";
const email_already_has_account =
  "This e-mail already has an account. Please try signing in and purchasing the course";
const invalid_credentials = "Invalid Credentials";
const account_doesnot_exist = "Account does not exist";

const your_order_heading = "Your Order";
const your_order_summary_heading = "Your order summary";
const create_account_title = "Create Account";
const first_name_input_label = "First Name";
const last_name_input_label = "Last Name";
const your_email_input_label = "Your Email";
const choose_password_input_label = "Choose Password";
const sudomain_address_select_heading = "Select subdomain address";
const subdomain_text_input_group_label = "Subdomain";
const subdomain_text_input_group_placeholder = "yoursitename";
const domain_not_available_text = "This domain is currently unavailable";
const select_payment_method_heading = "Select payment method";
const card_payment_title = "Card Payment";
const card_payment_helper_text = "You can choose card payment for this order";
const invoice_payment_title = "Invoice Payment";
const invoice_payment_helper_text = "You can choose invoice for this order";
const password_input_label = "Password";
const email_input_label = "Email";
const group_details_heading = "Group Details";
const participants_details_heading = "Participant Details";
const participant_email_exist_error =
  "This user is already registered in this course. Please change the participant";
const duplicate_email = "Each user needs a unique email address";

const shop_preview_no_courses =
  "Currently You do not have any courses in your shop.";

const general_information_text = "General Information";
const information_not_available_text = "Information not available";
const secure_transaction_text = "Secure transaction";
const sold_through_text = "Sold through";
const provided_by_text = "Provided by";
const return_policy_text = "Return policy";
const not_eligible_for_return_text =
  "Not eligible for return, refund or replacement";
const support_text = "Support";
const free_support_plan_included = "Free Sparkfore support plan included";
const licenses_available_days = "Licenses available : 365 days";

const start_menu_item = "Start";
const users_menu_item = "Users";
const groups_menu_item = "Groups";
const courses_menu_item = "Courses";
const reports_menu_item = "Reports";
const company_account_menu_item = "Company Account";
const company_profile_menu_item = "Company Profile";
const signup_up_forms_menu_item = "Signup Forms";
const webshop_menu_item = "Webshop";
const control_panel_menu_item = "Control Panel";
const dashboard_menu_item = "Dashboard";
const customer_settings_menu_item = "Customer Settings";
const general_settings_menu_item = "General Settings";

const select_suddomain_step_title = "Select Subdomain";
const payment_method = "Payment Method";
const participants = "Participants";
const create_or_signin_step_title = "Create or Sign-In";

const sparkfore_educator_license_label = "Sparkfore Educator";
const sparkfore_enterprise_license_label = "Sparkfore Enterprise";
const sparkfore_team_license_label = "Sparkfore Team";
const search_placeholder = "Search";
const profile_dropdown_link_title = "Profile";
const logout_dropdown_link_title = "Logout";
const switch_role_dropdown_link_title = "Switch role to...";

const form_title_create_new_form = "Create New Form";
const form_title_custom_signup_page = "Custom Sign-Up Page";
const form_title_share_link = "Share Link";

const warning_header = "Warning";
const cancel_button_label = "Cancel";
const save_button_label = "Save";
const update_button_label = "Update";
const information_heading = "Information";
const submit_button_label = "Submit";
const continue_button_label = "Continue";
const copy_button_label = "Copy";
const edit_button_label = "Edit";
const delete_button_label = "Delete";
const buy_button_label = "Buy";
const login_to_view_pricing = "Login to view pricing";
const error_text = "Error";
const feature_not_available_text =
  "This feature is not enabled in your account. Please contact support";
const operation_could_not_completed_text = "Operation could not be completed";
const thanks_for_order_heading = "Thanks for the Order";
const order_confirmation_mail_sent_text =
  "Thank you for your order, we have sent an order confirmation and all info to your email. Below you will find more detailed information on your order.";
const order_number_text = "Order number";
const product_text = "Product";
const domain_text = "Domain";
const payment_period_text = "Payment period";
const total_cost_text = "Total Cost";
const total_text = "Total";
const customer_pages_heading = "Сustomer Pages";
const customer_pages_text =
  "Visit the Customer Pages to view details about your user details, purchases and licenses.";
const open_button_label = "Open";
const contact_us_button_label = "Contact Us";
const stripe_api_error_text =
  "Looks like we couldn't connect to Stripe to receive your session data";
const purchase_could_not_completed_heading =
  "Your purchase could not be completed";
const purchase_could_not_completed_text =
  "We could not complete your order as the payment was not valid. For assistance, please contact Sparkfore Support at support@sparkfore.com";
const marketing_consent_text =
  "Please also send me occasional emails about Sparkfore products and services";
const marketing_consent_helper_text = "You can unsubscribe at any time";
const please_try_again_text = "Please try again";
const invoice_creation_status_heading = "Invoice Status";
const invoice_creation_failed_text = "Creating Invoice Failed";
const loading_text = "Loading";
const type_placeholder = "Type";
const go_back_button_label = "Go Back";
const autotech_development_text = "Autotech Development";
const input_code_here = "Input Code Here..";
const sparkfore_team = "Sparkfore Team";
const upload_your_picture_input = "Upload your picture";
const or_click_here_text = "or click here";
const delete_file_button_label = "Delete File";
const remove_file_title = "Remove File";
const captcha_input_label = "Captcha";
const yes_text = "Yes";
const no_text = "No";
const day_text = "day";
const days_text = "days";
const hour_text = "hour";
const hours_text = "hours";
const minute_text = "minute";
const minutes_text = "minutes";
const and_text = "and";
const external_id = "External Id";

const instructorled = "Instructor Led (ILT)";
const elearning = "Elearning";
const course_type = "Course Type";

const forbidden_page_text = "You are forbidden to access this page...";
const not_found_page_text = "Page Not Found";
const internal_server_error_text = "Internal Server Error...";

const register_user_error = "Registering User Failed";
const updating_user_error = "Updating User Registration Count Failed";
const logging_in_user_error = "Logging In User Failed";
const enrolling_user_error = "Enrolling User Failed";

const course_name_table_header = "Course Name";
const date_table_header = "Event Date";
const location_table_header = "Location";
const available_slots_table_header = "Available Slots";
const last_day_for_reg_table_header = "Last Day for Registration";
const register_cta_button = "Register";
const sold_out_button = "Sold Out";
const out_of_text = "Out of";
const city_selector_placeholder = "Select City";
const month_selector_placeholder = "Select Month";
const no_quantity_warning_title = "Cannot proceed with an invalid quantity";
const no_quantity_warning_text = "Please add a valid quantity and try again";
const no_events_message =
  "There are no events at the moment. Please reach us via the 'Contact Us' button so we can reach out to you.";
const contact_us_form_email_input_label = "Email";
const contact_us_form_telephone_input_label = "Telephone";
const contact_us_contact_company_name_input_label = "Contact Company Name";
const contact_us_contact_company_address_input_label =
  "Contact Company Address";
const contact_us_message_input_label = "Message";
const contact_us_company_address_input_label = "Company Address";
const contact_us_form_submit_success_message = "Inquiry Submitted Successfully";
const webshop_quantity = "Quantity";
const webshop_per_license_text = "per license";
const sign_in_user_notification_for_new_users =
  "The users will be added to your existing company account. Contact {Team Lead Name} for more details";

const organization_name_label = "Organization Name";
const group_name_label = "Group Name";
const participant_title = "Participant";
const user_assigned_to_course_error = "User already assigned to this course";
const payment_successful = "Payment Completed";

// customer management
const customer_management_title = "Customer Management";
const add_customer_tab_title = "Add Company";
const proceed_to_settings_form_button_label = "Proceed to Settings";
const address_input_label = "Address";
const postal_code_input_label = "Postal Code";
const city_input_label = "City";
const country_input_label = "Country";
const invoice_reference_input_label = "Invoice Reference";
const invoive_email_input_label = "Invoice Email";
const company_details_step_label = "Company Details";
const company_settings_step_label = "Company Settings";
const team_lead_label = "Team Tead";
const allow_invoice_label = "Allow Invoice";
const max_allowed_licenses_label = "Max Allowed Licenses";
const discount_label = "Discount";
const discount_placeholder = "Set Discount";
const team_lead_placeholder = "Select Team Lead";
const save_company_button_label = "Save Company";
const created_date_label = "Created Date :";
const last_modified_date_label = "Last Changed Date :";
const activation_toggle_label = "Activate";
const inactivation_toggle_label = "Inactive";
const add_user_link_label = "Click here to add an user as a team lead";
const webshop_settings_preview_item = "Product preview view";

const webshop_company_licence_max_allowed_reached_warning =
  "Maximum allowed license has reached. Please contact your vendor";
const buyer_doesnt_belong_to_a_company_error =
  "The logged in user does not belong to a customer account";
const vendor_text = "Vendor";
const inactive_company_warning =
  "The assigned company for this user is currently inactive. You are denied from making a purchase.";
const company_already_has_account =
  "This organisation number already has a company account. Please try signing in and purchasing the course";

const asc = "Asc";
const desc = "Desc";
const on = "Starts on";
const at = "Venue";
const available = "Available seats";
const ends_on = "Registration ends on";

const invoicing_address_data_title = "Invoicing address information";
const invoicing_address_data_description =
  "Please complete the invoicing address information before proceeding.";

const isoLangs = [
  { code: "ab", name: "Abkhaz", nativeName: "аҧсуа" },
  { code: "aa", name: "Afar", nativeName: "Afaraf" },
  { code: "af", name: "Afrikaans", nativeName: "Afrikaans" },
  { code: "ak", name: "Akan", nativeName: "Akan" },
  { code: "sq", name: "Albanian", nativeName: "Shqip" },
  { code: "am", name: "Amharic", nativeName: "አማርኛ" },
  { code: "ar", name: "Arabic", nativeName: "العربية" },
  { code: "an", name: "Aragonese", nativeName: "Aragonés" },
  { code: "hy", name: "Armenian", nativeName: "Հայերեն" },
  { code: "as", name: "Assamese", nativeName: "অসমীয়া" },
  { code: "av", name: "Avaric", nativeName: "авар мацӀ, магӀарул мацӀ" },
  { code: "ae", name: "Avestan", nativeName: "avesta" },
  { code: "ay", name: "Aymara", nativeName: "aymar aru" },
  { code: "az", name: "Azerbaijani", nativeName: "azərbaycan dili" },
  { code: "bm", name: "Bambara", nativeName: "bamanankan" },
  { code: "ba", name: "Bashkir", nativeName: "башҡорт теле" },
  { code: "eu", name: "Basque", nativeName: "euskara, euskera" },
  { code: "be", name: "Belarusian", nativeName: "Беларуская" },
  { code: "bn", name: "Bengali", nativeName: "বাংলা" },
  { code: "bh", name: "Bihari", nativeName: "भोजपुरी" },
  { code: "bi", name: "Bislama", nativeName: "Bislama" },
  { code: "bs", name: "Bosnian", nativeName: "bosanski jezik" },
  { code: "br", name: "Breton", nativeName: "brezhoneg" },
  { code: "bg", name: "Bulgarian", nativeName: "български език" },
  { code: "my", name: "Burmese", nativeName: "ဗမာစာ" },
  { code: "ca", name: "Catalan; Valencian", nativeName: "Català" },
  { code: "ch", name: "Chamorro", nativeName: "Chamoru" },
  { code: "ce", name: "Chechen", nativeName: "нохчийн мотт" },
  {
    code: "ny",
    name: "Chichewa; Chewa; Nyanja",
    nativeName: "chiCheŵa, chinyanja",
  },
  { code: "zh", name: "Chinese", nativeName: "中文 (Zhōngwén), 汉语, 漢語" },
  { code: "cv", name: "Chuvash", nativeName: "чӑваш чӗлхи" },
  { code: "kw", name: "Cornish", nativeName: "Kernewek" },
  { code: "co", name: "Corsican", nativeName: "corsu, lingua corsa" },
  { code: "cr", name: "Cree", nativeName: "ᓀᐦᐃᔭᐍᐏᐣ" },
  { code: "hr", name: "Croatian", nativeName: "hrvatski" },
  { code: "cs", name: "Czech", nativeName: "česky, čeština" },
  { code: "da", name: "Danish", nativeName: "dansk" },
  { code: "dv", name: "Divehi; Dhivehi; Maldivian;", nativeName: "ދިވެހި" },
  { code: "nl", name: "Dutch", nativeName: "Nederlands, Vlaams" },
  { code: "en", name: "English", nativeName: "English" },
  { code: "eo", name: "Esperanto", nativeName: "Esperanto" },
  { code: "et", name: "Estonian", nativeName: "eesti, eesti keel" },
  { code: "ee", name: "Ewe", nativeName: "Eʋegbe" },
  { code: "fo", name: "Faroese", nativeName: "føroyskt" },
  { code: "fj", name: "Fijian", nativeName: "vosa Vakaviti" },
  { code: "fi", name: "Finnish", nativeName: "suomi, suomen kieli" },
  { code: "fr", name: "French", nativeName: "français, langue française" },
  {
    code: "ff",
    name: "Fula; Fulah; Pulaar; Pular",
    nativeName: "Fulfulde, Pulaar, Pular",
  },
  { code: "gl", name: "Galician", nativeName: "Galego" },
  { code: "ka", name: "Georgian", nativeName: "ქართული" },
  { code: "de", name: "German", nativeName: "Deutsch" },
  { code: "el", name: "Greek, Modern", nativeName: "Ελληνικά" },
  { code: "gn", name: "Guaraní", nativeName: "Avañeẽ" },
  { code: "gu", name: "Gujarati", nativeName: "ગુજરાતી" },
  { code: "ht", name: "Haitian; Haitian Creole", nativeName: "Kreyòl ayisyen" },
  { code: "ha", name: "Hausa", nativeName: "Hausa, هَوُسَ" },
  { code: "he", name: "Hebrew (modern)", nativeName: "עברית" },
  { code: "hz", name: "Herero", nativeName: "Otjiherero" },
  { code: "hi", name: "Hindi", nativeName: "हिन्दी, हिंदी" },
  { code: "ho", name: "Hiri Motu", nativeName: "Hiri Motu" },
  { code: "hu", name: "Hungarian", nativeName: "Magyar" },
  { code: "ia", name: "Interlingua", nativeName: "Interlingua" },
  { code: "id", name: "Indonesian", nativeName: "Bahasa Indonesia" },
  {
    code: "ie",
    name: "Interlingue",
    nativeName: "Originally called Occidental; then Interlingue after WWII",
  },
  { code: "ga", name: "Irish", nativeName: "Gaeilge" },
  { code: "ig", name: "Igbo", nativeName: "Asụsụ Igbo" },
  { code: "ik", name: "Inupiaq", nativeName: "Iñupiaq, Iñupiatun" },
  { code: "io", name: "Ido", nativeName: "Ido" },
  { code: "is", name: "Icelandic", nativeName: "Íslenska" },
  { code: "it", name: "Italian", nativeName: "Italiano" },
  { code: "iu", name: "Inuktitut", nativeName: "ᐃᓄᒃᑎᑐᑦ" },
  { code: "ja", name: "Japanese", nativeName: "日本語 (にほんご／にっぽんご)" },
  { code: "jv", name: "Javanese", nativeName: "basa Jawa" },
  {
    code: "kl",
    name: "Kalaallisut, Greenlandic",
    nativeName: "kalaallisut, kalaallit oqaasii",
  },
  { code: "kn", name: "Kannada", nativeName: "ಕನ್ನಡ" },
  { code: "kr", name: "Kanuri", nativeName: "Kanuri" },
  { code: "ks", name: "Kashmiri", nativeName: "कश्मीरी, كشميري‎" },
  { code: "kk", name: "Kazakh", nativeName: "Қазақ тілі" },
  { code: "km", name: "Khmer", nativeName: "ភាសាខ្មែរ" },
  { code: "ki", name: "Kikuyu, Gikuyu", nativeName: "Gĩkũyũ" },
  { code: "rw", name: "Kinyarwanda", nativeName: "Ikinyarwanda" },
  { code: "ky", name: "Kirghiz, Kyrgyz", nativeName: "кыргыз тили" },
  { code: "kv", name: "Komi", nativeName: "коми кыв" },
  { code: "kg", name: "Kongo", nativeName: "KiKongo" },
  {
    code: "ko",
    name: "Korean",
    nativeName: "한국어 (韓國語), 조선말 (朝鮮語)",
  },
  { code: "ku", name: "Kurdish", nativeName: "Kurdî, كوردی‎" },
  { code: "kj", name: "Kwanyama, Kuanyama", nativeName: "Kuanyama" },
  { code: "la", name: "Latin", nativeName: "latine, lingua latina" },
  {
    code: "lb",
    name: "Luxembourgish, Letzeburgesch",
    nativeName: "Lëtzebuergesch",
  },
  { code: "lg", name: "Luganda", nativeName: "Luganda" },
  {
    code: "li",
    name: "Limburgish, Limburgan, Limburger",
    nativeName: "Limburgs",
  },
  { code: "ln", name: "Lingala", nativeName: "Lingála" },
  { code: "lo", name: "Lao", nativeName: "ພາສາລາວ" },
  { code: "lt", name: "Lithuanian", nativeName: "lietuvių kalba" },
  { code: "lu", name: "Luba-Katanga", nativeName: "" },
  { code: "lv", name: "Latvian", nativeName: "latviešu valoda" },
  { code: "gv", name: "Manx", nativeName: "Gaelg, Gailck" },
  { code: "mk", name: "Macedonian", nativeName: "македонски јазик" },
  { code: "mg", name: "Malagasy", nativeName: "Malagasy fiteny" },
  { code: "ms", name: "Malay", nativeName: "bahasa Melayu, بهاس ملايو‎" },
  { code: "ml", name: "Malayalam", nativeName: "മലയാളം" },
  { code: "mt", name: "Maltese", nativeName: "Malti" },
  { code: "mi", name: "Māori", nativeName: "te reo Māori" },
  { code: "mr", name: "Marathi (Marāṭhī)", nativeName: "मराठी" },
  { code: "mh", name: "Marshallese", nativeName: "Kajin M̧ajeļ" },
  { code: "mn", name: "Mongolian", nativeName: "монгол" },
  { code: "na", name: "Nauru", nativeName: "Ekakairũ Naoero" },
  { code: "nv", name: "Navajo, Navaho", nativeName: "Diné bizaad, Dinékʼehǰí" },
  { code: "nb", name: "Norwegian Bokmål", nativeName: "Norsk bokmål" },
  { code: "nd", name: "North Ndebele", nativeName: "isiNdebele" },
  { code: "ne", name: "Nepali", nativeName: "नेपाली" },
  { code: "ng", name: "Ndonga", nativeName: "Owambo" },
  { code: "nn", name: "Norwegian Nynorsk", nativeName: "Norsk nynorsk" },
  { code: "no", name: "Norwegian", nativeName: "Norsk" },
  { code: "ii", name: "Nuosu", nativeName: "ꆈꌠ꒿ Nuosuhxop" },
  { code: "nr", name: "South Ndebele", nativeName: "isiNdebele" },
  { code: "oc", name: "Occitan", nativeName: "Occitan" },
  { code: "oj", name: "Ojibwe, Ojibwa", nativeName: "ᐊᓂᔑᓈᐯᒧᐎᓐ" },
  {
    code: "cu",
    name:
      "Old Church Slavonic, Church Slavic, Church Slavonic, Old Bulgarian, Old Slavonic",
    nativeName: "ѩзыкъ словѣньскъ",
  },
  { code: "om", name: "Oromo", nativeName: "Afaan Oromoo" },
  { code: "or", name: "Oriya", nativeName: "ଓଡ଼ିଆ" },
  { code: "os", name: "Ossetian, Ossetic", nativeName: "ирон æвзаг" },
  { code: "pa", name: "Panjabi, Punjabi", nativeName: "ਪੰਜਾਬੀ, پنجابی‎" },
  { code: "pi", name: "Pāli", nativeName: "पाऴि" },
  { code: "fa", name: "Persian", nativeName: "فارسی" },
  { code: "pl", name: "Polish", nativeName: "polski" },
  { code: "ps", name: "Pashto, Pushto", nativeName: "پښتو" },
  { code: "pt", name: "Portuguese", nativeName: "Português" },
  { code: "qu", name: "Quechua", nativeName: "Runa Simi, Kichwa" },
  { code: "rm", name: "Romansh", nativeName: "rumantsch grischun" },
  { code: "rn", name: "Kirundi", nativeName: "kiRundi" },
  { code: "ro", name: "Romanian, Moldavian, Moldovan", nativeName: "română" },
  { code: "ru", name: "Russian", nativeName: "русский язык" },
  { code: "sa", name: "Sanskrit (Saṁskṛta)", nativeName: "संस्कृतम्" },
  { code: "sc", name: "Sardinian", nativeName: "sardu" },
  { code: "sd", name: "Sindhi", nativeName: "सिन्धी, سنڌي، سندھی‎" },
  { code: "se", name: "Northern Sami", nativeName: "Davvisámegiella" },
  { code: "sm", name: "Samoan", nativeName: "gagana faa Samoa" },
  { code: "sg", name: "Sango", nativeName: "yângâ tî sängö" },
  { code: "sr", name: "Serbian", nativeName: "српски језик" },
  { code: "gd", name: "Scottish Gaelic; Gaelic", nativeName: "Gàidhlig" },
  { code: "sn", name: "Shona", nativeName: "chiShona" },
  { code: "si", name: "Sinhala, Sinhalese", nativeName: "සිංහල" },
  { code: "sk", name: "Slovak", nativeName: "slovenčina" },
  { code: "sl", name: "Slovene", nativeName: "slovenščina" },
  { code: "so", name: "Somali", nativeName: "Soomaaliga, af Soomaali" },
  { code: "st", name: "Southern Sotho", nativeName: "Sesotho" },
  { code: "es", name: "Spanish; Castilian", nativeName: "español, castellano" },
  { code: "su", name: "Sundanese", nativeName: "Basa Sunda" },
  { code: "sw", name: "Swahili", nativeName: "Kiswahili" },
  { code: "ss", name: "Swati", nativeName: "SiSwati" },
  { code: "sv", name: "Swedish", nativeName: "svenska" },
  { code: "ta", name: "Tamil", nativeName: "தமிழ்" },
  { code: "te", name: "Telugu", nativeName: "తెలుగు" },
  { code: "tg", name: "Tajik", nativeName: "тоҷикӣ, toğikī, تاجیکی‎" },
  { code: "th", name: "Thai", nativeName: "ไทย" },
  { code: "ti", name: "Tigrinya", nativeName: "ትግርኛ" },
  {
    code: "bo",
    name: "Tibetan Standard, Tibetan, Central",
    nativeName: "བོད་ཡིག",
  },
  { code: "tk", name: "Turkmen", nativeName: "Türkmen, Түркмен" },
  { code: "tl", name: "Tagalog", nativeName: "Wikang Tagalog, ᜏᜒᜃᜅ᜔ ᜆᜄᜎᜓᜄ᜔" },
  { code: "tn", name: "Tswana", nativeName: "Setswana" },
  { code: "to", name: "Tonga (Tonga Islands)", nativeName: "faka Tonga" },
  { code: "tr", name: "Turkish", nativeName: "Türkçe" },
  { code: "ts", name: "Tsonga", nativeName: "Xitsonga" },
  { code: "tt", name: "Tatar", nativeName: "татарча, tatarça, تاتارچا‎" },
  { code: "tw", name: "Twi", nativeName: "Twi" },
  { code: "ty", name: "Tahitian", nativeName: "Reo Tahiti" },
  { code: "ug", name: "Uighur, Uyghur", nativeName: "Uyƣurqə, ئۇيغۇرچە‎" },
  { code: "uk", name: "Ukrainian", nativeName: "українська" },
  { code: "ur", name: "Urdu", nativeName: "اردو" },
  { code: "uz", name: "Uzbek", nativeName: "zbek, Ўзбек, أۇزبېك‎" },
  { code: "ve", name: "Venda", nativeName: "Tshivenḓa" },
  { code: "vi", name: "Vietnamese", nativeName: "Tiếng Việt" },
  { code: "vo", name: "Volapük", nativeName: "Volapük" },
  { code: "wa", name: "Walloon", nativeName: "Walon" },
  { code: "cy", name: "Welsh", nativeName: "Cymraeg" },
  { code: "wo", name: "Wolof", nativeName: "Wollof" },
  { code: "fy", name: "Western Frisian", nativeName: "Frysk" },
  { code: "xh", name: "Xhosa", nativeName: "isiXhosa" },
  { code: "yi", name: "Yiddish", nativeName: "ייִדיש" },
  { code: "yo", name: "Yoruba", nativeName: "Yorùbá" },
  { code: "za", name: "Zhuang, Chuang", nativeName: "Saɯ cueŋƅ, Saw cuengh" },
];

// TEXT END
export default {
  hello_world: hello_world,

  manager: manager,
  coursecreator: coursecreator,
  editingteacher: editingteacher,
  teacher: teacher,
  student: student,
  guest: guest,
  user: user,
  frontpage: frontpage,

  trainingmanager: trainingmanager,
  privacyofficer: privacyofficer,
  localmanager: localmanager,
  wsuser: wsuser,
  teamlead: teamlead,
  regionmanager: regionmanager,
  instructor: instructor,
  it: it,

  siteadmin: siteadmin,
  sparkforeadmin: sparkforeadmin,

  auth_user: auth_user,

  common_error_title: common_error_title,

  general_password_validation_message: general_password_validation_message,
  subdomain_can_contain_alphanumeric_chars_message: subdomain_can_contain_alphanumeric_chars_message,
  censorship_triggered_message: censorship_triggered_message,
  subdomain_not_available_message: subdomain_not_available_message,
  choose_different_subdomain_message: choose_different_subdomain_message,
  invalid_input_error_message: invalid_input_error_message,
  close_button_label: close_button_label,

  // Super Admin - Manage Customers
  add_new_customer_button_label: add_new_customer_button_label,
  customer_label: customer_label,
  organization_number_label: organization_number_label,
  customer_instance_id_label: customer_instance_id_label,
  guid_label: guid_label,
  secret_key_label: secret_key_label,
  lms_url_label: lms_url_label,
  license_type_label: license_type_label,
  select_license_placeholder: select_license_placeholder,
  customer_settings_header: customer_settings_header,
  stripe_connect_account_header: stripe_connect_account_header,
  create_account_button_label: create_account_button_label,
  save_settings_button_label: save_settings_button_label,
  add_new_customer_info_message: add_new_customer_info_message,
  account_name_label: account_name_label,
  delete_stripe_connect_account_message: delete_stripe_connect_account_message,

  // Company Profile
  company_email_input_label: company_email_input_label,
  company_number_input_label: company_number_input_label,
  company_name_input_label: company_name_input_label,
  company_name_input_label_s: company_name_input_label_s,
  phone_input_label: phone_input_label,

  invoicing_address_input_label: invoicing_address_input_label,
  zip_code_input_label: zip_code_input_label,

  account_manager_input_label: account_manager_input_label,
  customer_team_lead_ac_input_label: customer_team_lead_ac_input_label,
  save_changes_button_label: save_changes_button_label,
  customer_profile_retrieval_error_message: customer_profile_retrieval_error_message,
  customer_profile_retrieval_status_heading: customer_profile_retrieval_status_heading,
  customer_profile_update_success_heading: customer_profile_update_success_heading,
  customer_profile_update_success_message: customer_profile_update_success_message,
  customer_profile_update_fail_heading: customer_profile_update_fail_heading,
  customer_profile_update_fail_message: customer_profile_update_fail_message,
  customer_profile_update_status_heading: customer_profile_update_status_heading,
  customer_profile_update_error_message: customer_profile_update_error_message,

  // Signup Forms
  signup_forms_heading: signup_forms_heading,
  overview_tab_title: overview_tab_title,
  signup_form_list_item_custom_description_title: signup_form_list_item_custom_description_title,
  signup_forms_no_data_text: signup_forms_no_data_text,
  signup_forms_no_data_add_form_text: signup_forms_no_data_add_form_text,
  custom_title_input_label: custom_title_input_label,
  custom_title_input_placeholder: custom_title_input_placeholder,
  custom_description_input_label: custom_description_input_label,
  custom_description_input_placeholder: custom_description_input_placeholder,
  logo_input_label: logo_input_label,
  logo_input_placeholder: logo_input_placeholder,
  logo_input_drop_placeholder: logo_input_drop_placeholder,
  add_other_fields_input_group_label: add_other_fields_input_group_label,
  add_fields_button_label: add_fields_button_label,
  delete_fields_button_label: delete_fields_button_label,
  delete_field_button_label: delete_field_button_label,
  delete_form_warning_message: delete_form_warning_message,
  link_copied_success_toast_message: link_copied_success_toast_message,
  update_form_heading: update_form_heading,
  courses_to_enrol_after_signup_input_label: courses_to_enrol_after_signup_input_label,
  select_courses_placeholder: select_courses_placeholder,
  select_courses_tag_placeholder: select_courses_tag_placeholder,
  registration_domain_limit_input_label: registration_domain_limit_input_label,
  registration_domain_limit_tag_placeholder: registration_domain_limit_tag_placeholder,
  max_allowed_registrations_input_label: max_allowed_registrations_input_label,
  proceed_to_create_form_button_label: proceed_to_create_form_button_label,
  proceed_to_generate_link_button_label: proceed_to_generate_link_button_label,
  signup_form_share_helper_text: signup_form_share_helper_text,
  generated_link_input_group_label: generated_link_input_group_label,
  generated_link_placeholder: generated_link_placeholder,
  copy_url_address_button_label: copy_url_address_button_label,
  back_to_overview_button_label: back_to_overview_button_label,

  // Subscription
  my_subscription_title: my_subscription_title,
  subscription_payment_helper_text: subscription_payment_helper_text,
  participants_title: participants_title,
  participant_invoice_helper_text: participant_invoice_helper_text,
  new_participants_per_month_text: new_participants_per_month_text,
  participants_all_time_text: participants_all_time_text,
  subscription_status_error_heading: subscription_status_error_heading,
  subscription_status_error_message: subscription_status_error_message,
  error_retrieving_subscription_heading: error_retrieving_subscription_heading,
  no_subscription_id_message: no_subscription_id_message,
  customer_instance_creation_failed_message: customer_instance_creation_failed_message,
  retrieving_session_error_heading: retrieving_session_error_heading,
  subscription_creation_success_message: subscription_creation_success_message,
  subscription_creation_error_message: subscription_creation_error_message,
  no_invoice_message: no_invoice_message,
  no_order_message: no_order_message,
  date_label: date_label,
  order_details_label: order_details_label,
  name_label: name_label,
  email_label: email_label,
  options_label: options_label,
  approve_btn_label: approve_btn_label,
  decline_btn_label: decline_btn_label,
  invoice_approval_heading: invoice_approval_heading,
  order_history_heading: order_history_heading,
  course_title_label: course_title_label,
  quantity_label: quantity_label,
  order_sum_label: order_sum_label,
  payment_method_label: payment_method_label,
  invoice_payment_label: invoice_payment_label,
  card_payment_label: card_payment_label,
  date_range_label: date_range_label,
  purchaser_name_label: purchaser_name_label,
  pending_card_payment_label: pending_card_payment_label,
  view_order_label: view_order_label,

  //Customer Account Portal
  portal_licenses_title: portal_licenses_title,
  portal_licenses_helper_text: portal_licenses_helper_text,
  portal_coursecompletions_title: portal_coursecompletions_title,
  portal_coursecompletions_helper_text: portal_coursecompletions_helper_text,
  portal_certificaterenewals_title: portal_certificaterenewals_title,
  portal_certificaterenewals_helper_text: portal_certificaterenewals_helper_text,
  last30days: last30days,
  thisyear: thisyear,
  next3months: next3months,
  next12months: next12months,
  last12months: last12months,
  no_company_message: no_company_message,

  // Webshop
  webshop_header_text: webshop_header_text,
  enable_webshop_helper_text: enable_webshop_helper_text,
  onboard_your_account_button_label: onboard_your_account_button_label,
  generated_webshop_code_text_group_text: generated_webshop_code_text_group_text,
  generate_code_button_label: generate_code_button_label,
  in_webshop_column_title: in_webshop_column_title,
  course_title_column_title: course_title_column_title,
  price_column_title: price_column_title,
  shop_preview_tab_title: shop_preview_tab_title,
  webshop_save_error_message: webshop_save_error_message,
  iframe_copied_success_text: iframe_copied_success_text,
  approximation_time_text: approximation_time_text,
  languages_placeholder: languages_placeholder,
  length_text: length_text,
  shop_text: shop_text,
  not_available_short_text: not_available_short_text,
  sign_in_user_notification_for_new_users: sign_in_user_notification_for_new_users,

  courses_header_text: courses_header_text,
  settings_tab_title: settings_tab_title,
  external_id: external_id,

  instructorled: instructorled,
  elearning: elearning,
  course_type: course_type,

  // Sparkfore Login
  username_input_placeholder: username_input_placeholder,
  password_input_placeholder: password_input_placeholder,
  login_button_label: login_button_label,
  forgot_password_link_label: forgot_password_link_label,

  email_input_placeholder: email_input_placeholder,
  send_password_reset_link_button_label: send_password_reset_link_button_label,
  back_to_login_button_label: back_to_login_button_label,

  // Signup Form - Public
  form_image_alt_text: form_image_alt_text,
  form_not_available_text: form_not_available_text,
  account_created_success_text: account_created_success_text,

  // Webshop - Public
  registration_successful_with_redirection_text: registration_successful_with_redirection_text,
  create_webshop_payment_failed_text: create_webshop_payment_failed_text,
  payment_status_heading: payment_status_heading,
  contintue_with_payment_button_label: contintue_with_payment_button_label,
  email_already_has_account: email_already_has_account,
  invalid_credentials: invalid_credentials,
  account_doesnot_exist: account_doesnot_exist,

  // Customer Instance Purchase
  your_order_heading: your_order_heading,
  your_order_summary_heading: your_order_summary_heading,
  create_account_title: create_account_title,
  first_name_input_label: first_name_input_label,
  last_name_input_label: last_name_input_label,
  your_email_input_label: your_email_input_label,
  choose_password_input_label: choose_password_input_label,
  sudomain_address_select_heading: sudomain_address_select_heading,
  subdomain_text_input_group_label: subdomain_text_input_group_label,
  subdomain_text_input_group_placeholder: subdomain_text_input_group_placeholder,
  domain_not_available_text: domain_not_available_text,
  select_payment_method_heading: select_payment_method_heading,
  card_payment_title: card_payment_title,
  card_payment_helper_text: card_payment_helper_text,
  invoice_payment_title: invoice_payment_title,
  invoice_payment_helper_text: invoice_payment_helper_text,
  sign_in_tab_title: sign_in_tab_title,

  // Shop Preview
  shop_preview_no_courses: shop_preview_no_courses,

  // Shop Course Item Preview
  general_information_text: general_information_text,
  information_not_available_text: information_not_available_text,
  secure_transaction_text: secure_transaction_text,
  sold_through_text: sold_through_text,
  provided_by_text: provided_by_text,
  return_policy_text: return_policy_text,
  not_eligible_for_return_text: not_eligible_for_return_text,
  support_text: support_text,
  free_support_plan_included: free_support_plan_included,
  licenses_available_days: licenses_available_days,

  // Menu Items
  start_menu_item: start_menu_item,
  users_menu_item: users_menu_item,
  groups_menu_item: groups_menu_item,
  courses_menu_item: courses_menu_item,
  reports_menu_item: reports_menu_item,
  company_account_menu_item: company_account_menu_item,
  company_profile_menu_item: company_profile_menu_item,
  signup_up_forms_menu_item: signup_up_forms_menu_item,
  webshop_menu_item: webshop_menu_item,
  control_panel_menu_item: control_panel_menu_item,
  dashboard_menu_item: dashboard_menu_item,
  customer_settings_menu_item: customer_settings_menu_item,
  general_settings_menu_item: general_settings_menu_item,

  // Header Titles
  select_suddomain_step_title: select_suddomain_step_title,
  payment_method: payment_method,
  participants: participants,
  create_or_signin_step_title: create_or_signin_step_title,
  search_placeholder: search_placeholder,
  profile_dropdown_link_title: profile_dropdown_link_title,
  logout_dropdown_link_title: logout_dropdown_link_title,
  switch_role_dropdown_link_title: switch_role_dropdown_link_title,

  // Store
  form_title_create_new_form: form_title_create_new_form,
  form_title_custom_signup_page: form_title_custom_signup_page,
  form_title_share_link: form_title_share_link,

  // Licenses
  sparkfore_educator_license_label: sparkfore_educator_license_label,
  sparkfore_enterprise_license_label: sparkfore_enterprise_license_label,
  sparkfore_team_license_label: sparkfore_team_license_label,

  // Common
  warning_header: warning_header,
  cancel_button_label: cancel_button_label,
  save_button_label: save_button_label,
  update_button_label: update_button_label,
  information_heading: information_heading,
  submit_button_label: submit_button_label,
  continue_button_label: continue_button_label,
  copy_button_label: copy_button_label,
  edit_button_label: edit_button_label,
  delete_button_label: delete_button_label,
  buy_button_label: buy_button_label,
  login_to_view_pricing: login_to_view_pricing,
  error_text: error_text,
  feature_not_available_text: feature_not_available_text,
  operation_could_not_completed_text: operation_could_not_completed_text,
  thanks_for_order_heading: thanks_for_order_heading,
  order_confirmation_mail_sent_text: order_confirmation_mail_sent_text,
  order_number_text: order_number_text,
  product_text: product_text,
  domain_text: domain_text,
  payment_period_text: payment_period_text,
  total_cost_text: total_cost_text,
  total_text: total_text,
  customer_pages_heading: customer_pages_heading,
  customer_pages_text: customer_pages_text,
  open_button_label: open_button_label,
  contact_us_button_label: contact_us_button_label,
  stripe_api_error_text: stripe_api_error_text,
  purchase_could_not_completed_heading: purchase_could_not_completed_heading,
  purchase_could_not_completed_text: purchase_could_not_completed_text,
  marketing_consent_text: marketing_consent_text,
  marketing_consent_helper_text: marketing_consent_helper_text,
  please_try_again_text: please_try_again_text,
  invoice_creation_status_heading: invoice_creation_status_heading,
  invoice_creation_failed_text: invoice_creation_failed_text,
  loading_text: loading_text,
  type_placeholder: type_placeholder,
  go_back_button_label: go_back_button_label,
  autotech_development_text: autotech_development_text,
  input_code_here: input_code_here,
  sparkfore_team: sparkfore_team,
  upload_your_picture_input: upload_your_picture_input,
  or_click_here_text: or_click_here_text,
  delete_file_button_label: delete_file_button_label,
  remove_file_title: remove_file_title,
  captcha_input_label: captcha_input_label,
  yes_text: yes_text,
  no_text: no_text,
  company_name_placeholder_label: company_name_placeholder_label,
  day_text: day_text,
  days_text: days_text,
  hour_text: hour_text,
  hours_text: hours_text,
  minute_text: minute_text,
  minutes_text: minutes_text,
  and_text: and_text,
  register_user_error: register_user_error,
  updating_user_error: updating_user_error,
  logging_in_user_error: logging_in_user_error,
  enrolling_user_error: enrolling_user_error,

  // ILT Webshop
  course_name_table_header: course_name_table_header,
  date_table_header: date_table_header,
  location_table_header: location_table_header,
  available_slots_table_header: available_slots_table_header,
  last_day_for_reg_table_header: last_day_for_reg_table_header,
  register_cta_button: register_cta_button,
  sold_out_button: sold_out_button,
  out_of_text: out_of_text,
  city_selector_placeholder: city_selector_placeholder,
  month_selector_placeholder: month_selector_placeholder,
  no_quantity_warning_title: no_quantity_warning_title,
  no_quantity_warning_text: no_quantity_warning_text,
  no_events_message: no_events_message,
  contact_us_form_email_input_label: contact_us_form_email_input_label,
  contact_us_form_telephone_input_label: contact_us_form_telephone_input_label,
  contact_us_contact_company_name_input_label: contact_us_contact_company_name_input_label,
  contact_us_contact_company_address_input_label: contact_us_contact_company_address_input_label,
  contact_us_message_input_label: contact_us_message_input_label,
  contact_us_company_address_input_label: contact_us_company_address_input_label,
  contact_us_form_submit_success_message: contact_us_form_submit_success_message,
  webshop_quantity: webshop_quantity,
  webshop_per_license_text: webshop_per_license_text,
  password_input_label: password_input_label,
  email_input_label: email_input_label,
  group_details_heading: group_details_heading,
  participants_details_heading: participants_details_heading,
  participant_title: participant_title,
  participant_email_exist_error: participant_email_exist_error,
  duplicate_email: duplicate_email,

  organization_name_label: organization_name_label,
  group_name_label: group_name_label,

  user_assigned_to_course_error: user_assigned_to_course_error,

  payment_successful: payment_successful,

  // Error Pages
  forbidden_page_text: forbidden_page_text,
  not_found_page_text: not_found_page_text,
  internal_server_error_text: internal_server_error_text,

  isoLangs: isoLangs,

  sparkfore_welcome_message: sparkfore_welcome_message,

  // customer management
  customer_management_title: customer_management_title,
  add_customer_tab_title: add_customer_tab_title,
  proceed_to_settings_form_button_label: proceed_to_settings_form_button_label,
  address_input_label: address_input_label,
  postal_code_input_label: postal_code_input_label,
  city_input_label: city_input_label,
  country_input_label: country_input_label,
  invoice_reference_input_label: invoice_reference_input_label,
  invoive_email_input_label: invoive_email_input_label,
  company_details_step_label: company_details_step_label,
  company_settings_step_label: company_settings_step_label,
  team_lead_label: team_lead_label,
  allow_invoice_label: allow_invoice_label,
  max_allowed_licenses_label: max_allowed_licenses_label,
  discount_label: discount_label,
  discount_placeholder: discount_placeholder,
  team_lead_placeholder: team_lead_placeholder,
  save_company_button_label: save_company_button_label,
  created_date_label: created_date_label,
  last_modified_date_label: last_modified_date_label,
  activation_toggle_label: activation_toggle_label,
  inactivation_toggle_label: inactivation_toggle_label,
  add_user_link_label: add_user_link_label,
  webshop_settings_preview_item: webshop_settings_preview_item,
  webshop_company_licence_max_allowed_reached_warning: webshop_company_licence_max_allowed_reached_warning,
  buyer_doesnt_belong_to_a_company_error: buyer_doesnt_belong_to_a_company_error,
  vendor_text: vendor_text,
  inactive_company_warning: inactive_company_warning,
  company_already_has_account: company_already_has_account,
  asc: asc,
  desc: desc,
  on: on,
  at: at,
  available: available,
  ends_on: ends_on,

  invoicing_address_data_title: invoicing_address_data_title,
  invoicing_address_data_description: invoicing_address_data_description,
};

// usage
// import Constants from "../constants/index";
